import { render, staticRenderFns } from "./EntityTemplateList.vue?vue&type=template&id=80740f7c&"
import script from "./EntityTemplateList.vue?vue&type=script&lang=js&"
export * from "./EntityTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EntityTemplateList.vue"
export default component.exports